// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2e13d5ffa63b4451f83e22300236b7a06127fe36.chunk.js";
};